var _style, _g, _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageQuestionnairesPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#600097;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,11l0.2,1.2c0.3,0.1,0.6,0.3,0.9,0.5l1.2-0.4l0.8,1.3l-0.9,0.8c0.1,0.3,0.1,0.7,0,1l0.9,0.8l-0.8,1.3 L17,17.3c-0.3,0.2-0.6,0.4-0.9,0.5L15.8,19h-1.6l-0.2-1.2c-0.3-0.1-0.6-0.3-0.9-0.5l-1.2,0.4L11,16.3l0.9-0.8c-0.1-0.3-0.1-0.7,0-1 L11,13.7l0.8-1.3l1.2,0.4c0.3-0.2,0.6-0.4,0.9-0.5l0.2-1.2L15.8,11 M15.8,10h-1.6c-0.5,0-0.9,0.3-1,0.8l-0.1,0.7 c-0.1,0-0.1,0.1-0.2,0.1l-0.7-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0-0.7,0.2-0.9,0.5l-0.8,1.3c-0.2,0.4-0.2,0.9,0.2,1.3l0.6,0.5 c0,0.1,0,0.1,0,0.2l-0.5,0.5c-0.4,0.3-0.5,0.9-0.2,1.3l0.8,1.3c0.2,0.3,0.5,0.5,0.9,0.5c0.1,0,0.2,0,0.3,0l0.7-0.2 c0.1,0,0.1,0.1,0.2,0.1l0.1,0.7c0.1,0.5,0.5,0.8,1,0.8h1.6c0.5,0,0.9-0.3,1-0.8l0.1-0.7c0.1,0,0.1-0.1,0.2-0.1l0.7,0.2 c0.1,0,0.2,0,0.3,0c0.3,0,0.7-0.2,0.9-0.5l0.8-1.3c0.2-0.4,0.2-0.9-0.2-1.3l-0.5-0.5c0-0.1,0-0.1,0-0.2l0.5-0.5 c0.4-0.3,0.5-0.9,0.2-1.3L19,11.8c-0.2-0.3-0.5-0.5-0.9-0.5c-0.1,0-0.2,0-0.3,0.1l-0.7,0.2c-0.1,0-0.1-0.1-0.2-0.1l-0.1-0.7 C16.7,10.3,16.3,10,15.8,10C15.8,10,15.8,10,15.8,10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,14c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S14.4,14,15,14 M15,13c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2 S16.1,13,15,13L15,13z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.8,18.2V1.8h12.4V8H16V0.9C16,0.4,15.6,0,15.1,0H0.9C0.4,0,0,0.4,0,0.9v18.2C0,19.6,0.4,20,0.9,20H8v-1.8 L1.8,18.2L1.8,18.2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.8,
    className: "st0",
    width: 10,
    height: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 6.8,
    className: "st0",
    width: 8,
    height: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9.8,
    className: "st0",
    width: 9,
    height: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12.8,
    className: "st0",
    width: 6,
    height: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageQuestionnairesPurple);
export default __webpack_public_path__ + "static/media/Manage Questionnaires - Purple.6bd648e24b9884f0362532d3e65dac43.svg";
export { ForwardRef as ReactComponent };